import React, { Component } from "react";
import { VzPageContainer } from "../../layouts/VzPageContainer";
export default class ManageMFI extends Component {
  render() {
    return (
      <div>
        <VzPageContainer title="VizLink MFI's">
        </VzPageContainer>
      </div>
    );
  }
}
